import { DialogContent } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

export function ModalContent({ className, children, ...props }) {
  return (
    <DialogContent
      className={cn(
        `
        max-w-5xl
        max-h-[90vh]
        p-0
        overflow-y-auto
        rounded-2xl
        shadow-2xl
        border
        border-slate-200
        dark:border-slate-800
        bg-white
        dark:bg-slate-950
        text-slate-900
        dark:text-slate-100

        [&>button]:right-4
        [&>button]:top-4
        [&>button]:h-9
        [&>button]:w-9
        [&>button]:flex
        [&>button]:items-center
        [&>button]:justify-center
        [&>button]:rounded-lg
        [&>button]:border
        [&>button]:border-white/10
        [&>button]:bg-white/10
        [&>button]:text-white
        [&>button]:opacity-100
        [&>button]:transition-all
        hover:[&>button]:bg-white/20
        `,
        className,
      )}
      {...props}
    >
      {children}
    </DialogContent>
  );
}
